import ABCyaLib from '@abcya/abcya_lib';
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import CompletedLetterView from '../game/CompletedLetterView';
import PrintScreenMenu from '../game/PrintScreenMenu';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import CreatorScreen from './CreatorScreen';

export default class PrintScreen extends Phaser.Scene
{
    static get KEY() { return 'PrintScreen'; }

    constructor()
    {
        super({ key: (PrintScreen).KEY });
    }

    create()
    {
        this.add.rectangle(0, 0, this.scale.width, this.scale.height, 0x7dcece).setOrigin(0);

        this.fullLetter = new CompletedLetterView(this);
        this.add.existing(this.fullLetter);
        this.fullLetter.x = (this.scale.width / 2) - (this.fullLetter.letterWidth / 2);
        this.fullLetter.y = -this.fullLetter.letterHeight;

        ABCyaPhaser.Tweens.addTween(this.fullLetter, 600, { y: 30 }, Phaser.Math.Easing.Quadratic.Out);

        this.printMenu = new PrintScreenMenu(this);
        this.add.existing(this.printMenu);
        this.printMenu.x = 0;
        this.printMenu.y = this.scale.height + 100;
        this.printMenu.on("BTN_SELECT", this.handleMenuSelect, this);

        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._loop_then_pop, this);

        this.showPrintMenu();
    }

    handleMenuSelect(e)
    {
        let menuInput = e.menuItemName;

        if (menuInput == "SAVE" || menuInput == "PRINT")
        {
            this.handleShareBtn(menuInput);
        }
        else
        {
            gameData.creatorPageIndex = e.menuIndex;
            this.scene.start(CreatorScreen.KEY);
        }
    }

    handleShareBtn(shareType)
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._clickSound, this);

        let renderTexture = new Phaser.GameObjects.RenderTexture(this, 0, 0, this.fullLetter.letterWidth, this.fullLetter.letterHeight);
        renderTexture.draw(this.fullLetter, 0, 0);
        renderTexture.snapshot(async image =>
        {
            try
            {
                if (shareType == "SAVE")
                {
                    await ABCyaLib.PrintSave.instance.saveImage(image, { fileName: ABCyaPhaser.Localization.instance.getLocalizedString("letter.filename") });
                }
                else
                {
                    await ABCyaLib.PrintSave.instance.printImage(image);
                }
            }
            catch (ex)
            {
                console.warn(ex);
            }
            renderTexture.destroy();
        });
    }

    showPrintMenu()
    {
        ABCyaPhaser.Tweens.addTween(this.printMenu, 200, {delay: 400, y: this.scale.height-80}, Phaser.Math.Easing.Quadratic.Out);
    }
}